/**
 * Suvee Meal Card - Quantity State Manager
 * Handles toggling between zero state (plus only) and active state (minus/qty/plus)
 */
(function() {
    'use strict';

    /**
     * Update all meal card quantity displays
     */
    function updateQuantityDisplay() {
        document.querySelectorAll('.card--meal .quantity.cart-quantity, .price-per-item__container .quantity.cart-quantity, .product-sticky-footer .quantity.cart-quantity').forEach(function(container) {
            const input = container.querySelector('.quantity__input');
            if (!input) return;

            // Check both value attribute and data-cart-quantity for most accurate count
            const inputValue = parseInt(input.value, 10) || 0;
            const cartQuantity = parseInt(input.dataset.cartQuantity, 10) || 0;
            const actualValue = Math.max(inputValue, cartQuantity);

            if (actualValue > 0) {
                container.classList.add('quantity--has-items');
            } else {
                container.classList.remove('quantity--has-items');
            }
        });
    }

    /**
     * Initialize event listeners and observers
     */
    function init() {
        // Initial check
        updateQuantityDisplay();

        // Listen for input changes
        document.addEventListener('change', function(e) {
            if (e.target.classList.contains('quantity__input')) {
                setTimeout(updateQuantityDisplay, 10);
            }
        });

        // Listen for input events (typing)
        document.addEventListener('input', function(e) {
            if (e.target.classList.contains('quantity__input')) {
                setTimeout(updateQuantityDisplay, 10);
            }
        });

        // Listen for quantity button clicks
        document.addEventListener('click', function(e) {
            if (e.target.closest('.quantity__button')) {
                // Multiple timeouts to catch async updates from Shopify
                setTimeout(updateQuantityDisplay, 50);
                setTimeout(updateQuantityDisplay, 150);
                setTimeout(updateQuantityDisplay, 300);
                setTimeout(updateQuantityDisplay, 500);
                setTimeout(updateQuantityDisplay, 1000);
            }
        });

        // Listen for Shopify cart events
        document.addEventListener('cart:refresh', updateQuantityDisplay);
        document.addEventListener('cart:update', updateQuantityDisplay);
        document.addEventListener('cart:change', updateQuantityDisplay);

        // Listen for Shopify section re-render
        document.addEventListener('shopify:section:load', function() {
            setTimeout(updateQuantityDisplay, 100);
        });

        // MutationObserver to watch for DOM changes (AJAX updates)
        const observer = new MutationObserver(function(mutations) {
            let shouldUpdate = false;

            mutations.forEach(function(mutation) {
                // Check if quantity inputs were modified
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'value' || mutation.attributeName === 'data-cart-quantity') {
                        shouldUpdate = true;
                    }
                }

                // Check if new nodes were added (section re-render)
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            if (node.classList && (
                                node.classList.contains('quantity') ||
                                node.classList.contains('quick-add-bulk') ||
                                node.classList.contains('card--meal')
                            )) {
                                shouldUpdate = true;
                            }
                            // Check if added node contains quantity inputs
                            if (node.querySelector && node.querySelector('.quantity__input')) {
                                shouldUpdate = true;
                            }
                        }
                    });
                }

                // Check for attribute changes on inputs
                if (mutation.target.classList && mutation.target.classList.contains('quantity__input')) {
                    shouldUpdate = true;
                }
            });

            if (shouldUpdate) {
                updateQuantityDisplay();
            }
        });

        // Observe the entire document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value', 'data-cart-quantity']
        });

        // Override value property setter on quantity inputs to catch programmatic changes
        document.querySelectorAll('.card--meal .quantity__input, .price-per-item__container .quantity__input, .product-sticky-footer .quantity__input').forEach(function(input) {
            try {
                const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
                const originalSet = descriptor.set;

                Object.defineProperty(input, 'value', {
                    set: function(val) {
                        originalSet.call(this, val);
                        setTimeout(updateQuantityDisplay, 10);
                    },
                    get: descriptor.get
                });
            } catch (e) {
                // Fallback if property override fails
            }
        });

        // Intercept fetch requests to detect cart updates
        const originalFetch = window.fetch;
        window.fetch = function(...args) {
            return originalFetch.apply(this, args).then(function(response) {
                const url = args[0];
                if (typeof url === 'string' && (
                    url.includes('/cart/') ||
                    url.includes('cart.js') ||
                    url.includes('cart/change') ||
                    url.includes('cart/update') ||
                    url.includes('cart/add')
                )) {
                    setTimeout(updateQuantityDisplay, 100);
                    setTimeout(updateQuantityDisplay, 300);
                    setTimeout(updateQuantityDisplay, 500);
                    setTimeout(updateQuantityDisplay, 1000);
                }
                return response;
            });
        };

        // Intercept XMLHttpRequest for older implementations
        const originalXHROpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function(method, url) {
            this.addEventListener('load', function() {
                if (typeof url === 'string' && (
                    url.includes('/cart/') ||
                    url.includes('cart.js') ||
                    url.includes('cart/change') ||
                    url.includes('cart/update') ||
                    url.includes('cart/add')
                )) {
                    setTimeout(updateQuantityDisplay, 100);
                    setTimeout(updateQuantityDisplay, 300);
                    setTimeout(updateQuantityDisplay, 500);
                }
            });
            return originalXHROpen.apply(this, arguments);
        };
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Also run on window load as backup
    window.addEventListener('load', function() {
        setTimeout(updateQuantityDisplay, 50);
        setTimeout(updateQuantityDisplay, 90);
    });

    // Expose function globally for manual triggering if needed
    window.updateMealCardQuantityDisplay = updateQuantityDisplay;

})();